











































import { Component, Prop, Vue } from "vue-property-decorator";
import CreateSessionResultModel from "@/models/security/zorgID/createSessionResultModel";
import InitializeSessionComponent from "@/components/zorgID/InitializeSessionComponent.vue";
import OpenSessionComponent from "@/components/zorgID/OpenSessionComponent.vue";
import { SecurityService } from "../../services/SecurityService";
import InformationCard from "@/components/InformationCard.vue";

@Component({
  components: {
    InitializeSessionComponent,
    OpenSessionComponent,
    "information-card": InformationCard,
  },
})
export default class LogonComponent extends Vue {
  private isLoggedOn: boolean = false;

  public $refs!: Vue["$refs"] & {
    initializeSessionComponent: InitializeSessionComponent;
    openSessionComponent: OpenSessionComponent;
  };

  private btnInitializeSessionEnabled: boolean = true;

  // #region SessionInitialize

  private initializeSession() {
    var me = this;
    me.btnInitializeSessionEnabled = false;
    this.$refs.initializeSessionComponent.initializeSession();
  }

  private sessionInitialized(model: CreateSessionResultModel) {
    var me = this;
    this.$refs.openSessionComponent.openSession(model);
  }

  // #endregion

  // #region checkOpenedSessionStatus

  private btnLogoutEnabled: boolean = false;

  private sessionOpened() {
    var me = this;
    me.isLoggedOn = SecurityService.getInstance().isLoggedOn();
    me.btnInitializeSessionEnabled = true;
  }

  // #endregion
}
